import { createFileRoute } from "@tanstack/react-router"

import { LanesListView } from "@/features/lanes/components/lanes-list-view"
import { lanesOverviewQueryOptions } from "@/features/lanes/hooks/use-lanes"
import {
  parseLaneListFilter,
  type LaneListFilter,
} from "@/features/lanes/utils/list-filter"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/voxlane/lanes/")({
  // Optional: the sidebar's "Needs attention" / "Provisioning" views.
  validateSearch: (
    search: Record<string, unknown>
  ): { status?: LaneListFilter } => ({
    status: parseLaneListFilter(search.status),
  }),
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient } }) =>
    warm(queryClient, [
      lanesOverviewQueryOptions(),
    ]),
  component: LanesRoute,
})

function LanesRoute() {
  const { status } = Route.useSearch()
  return <LanesListView status={status} />
}
